import '../function/partial.mjs';
import '../function/partialRight.mjs';
import { camelCase } from '../string/camelCase.mjs';
import '../string/deburr.mjs';
import { isArray } from '../compat/predicate/isArray.mjs';
import '../compat/function/bind.mjs';
import '../compat/function/bindKey.mjs';
import '../compat/function/curry.mjs';
import '../compat/function/curryRight.mjs';
import '../compat/function/partial.mjs';
import '../compat/function/partialRight.mjs';
import { isPlainObject } from '../compat/predicate/isPlainObject.mjs';
import '../compat/toolkit.mjs';

function toCamelCaseKeys(obj) {
    if (isArray(obj)) {
        return obj.map(item => toCamelCaseKeys(item));
    }
    if (isPlainObject(obj)) {
        const result = {};
        const keys = Object.keys(obj);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const camelKey = camelCase(key);
            const camelCaseKeys = toCamelCaseKeys(obj[key]);
            result[camelKey] = camelCaseKeys;
        }
        return result;
    }
    return obj;
}

export { toCamelCaseKeys };
